import * as React from 'react';
import Svg, {Path} from 'react-native-svg';
const SvgComponent = props => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={24}
    viewBox="0 0 30 24"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#070A7A'}
      d="M28.759 1.509c-.03-.05-.06-.11-.11-.16a.999.999 0 0 0-.39-.29 3.58 3.58 0 0 0-2.19-.75H3.989c-.82 0-1.58.28-2.19.74-.14.06-.28.16-.39.29-.04.05-.08.11-.11.17a3.6 3.6 0 0 0-.92 2.4v16.13c0 1.99 1.62 3.61 3.61 3.61h22.07c1.99 0 3.61-1.62 3.61-3.61V3.909c0-.93-.35-1.77-.93-2.41l.02.01Zm-3.13.92-9.69 7.87c-.52.42-1.27.42-1.79 0l-9.69-7.87h21.18-.01Zm1.93 17.62c0 .82-.67 1.49-1.49 1.49H3.999c-.82 0-1.49-.67-1.49-1.49V3.919c0-.1 0-.2.03-.29l10.26 8.33c.64.53 1.44.79 2.23.79s1.59-.26 2.23-.79l10.26-8.33c.02.09.03.2.03.29v16.13h.01Z"
    />
  </Svg>
);
export default SvgComponent;
